var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Box } from '../Box';
import { Text } from '../Text';
var getMaxWidth = function (em) { return parseInt(em) - 0.01; };
var breakpoints = function (props) { return ({
    xs: "@media screen and (max-width: ".concat(getMaxWidth(props.theme.breakpoints[0]), "em)"),
    sm: "@media screen and (min-width: ".concat(props.theme.breakpoints[0], ") and (max-width: ").concat(getMaxWidth(props.theme.breakpoints[1]), "em)"),
    md: "@media screen and (min-width: ".concat(props.theme.breakpoints[1], ") and (max-width: ").concat(getMaxWidth(props.theme.breakpoints[2]), "em)"),
    lg: "@media screen and (min-width: ".concat(props.theme.breakpoints[2], ") and (max-width: ").concat(getMaxWidth(props.theme.breakpoints[3]), "em)"),
    xl: "@media screen and (min-width: ".concat(props.theme.breakpoints[3], ") and (max-width: ").concat(getMaxWidth(props.theme.breakpoints[4]), "em)"),
    xxl: "@media screen and (min-width: ".concat(props.theme.breakpoints[4], ")"),
    print: "@media print",
}); };
var hidden = function (key) { return function (props) {
    var _a;
    return props[key]
        ? (_a = {},
            _a[breakpoints(props)[key]] = {
                display: 'none',
            },
            _a) : null;
}; };
var propTypes = {
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
    xxl: PropTypes.bool,
    print: PropTypes.bool,
};
var Hide = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", ";\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", ";\n"])), hidden('xs'), hidden('sm'), hidden('md'), hidden('lg'), hidden('xl'), hidden('xxl'), hidden('print'));
Hide.propTypes = propTypes;
Hide.displayName = 'Hide';
Hide.text = styled(Text)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", ";\n"], ["\n  display: inline;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", ";\n"])), hidden('xs'), hidden('sm'), hidden('md'), hidden('lg'), hidden('xl'), hidden('xxl'), hidden('print'));
export default Hide;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Hide.js.map